// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.data-line:hover {\n  stroke: tomato; /* or any color you want */\n}", "",{"version":3,"sources":["webpack://./src/views/Dashboard/Dashboard/Companies/components/UnisonoFeaturesGraph/ScatterPlot.css"],"names":[],"mappings":";AACA;EACE,cAAc,EAAE,0BAA0B;AAC5C","sourcesContent":["\n.data-line:hover {\n  stroke: tomato; /* or any color you want */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
